import {
  IButtonProps,
  IImageProps,
  IPricePerUnitProps,
  IQuantityProps,
  ITextProps,
  ITotalPriceProps,
} from '../components';
import { IGeneralProductItemProps } from '../GeneralProductItem';
import { IGeneralProductItem } from '../model';

export interface IUseGeneralProductItem {
  key: string;
  generalProductItem: IGeneralProductItemProps;
  imageProps: IImageProps;
  textProps: ITextProps;
  pricePerUnitProps: IPricePerUnitProps;
  quantityProps: IQuantityProps;
  buttonProps: IButtonProps;
  totalPrice: ITotalPriceProps;
}

export const useGeneralProductItem = (products: IGeneralProductItem[]): IUseGeneralProductItem[] => {
  return products.map((product) => {
    const {
      dataTestId,
      price,
      itemQuantity,
      disabled,
      maximumQuantity,
      imageUrl,
      itemUrl,
      isEngraving,
      textContent,
      unitPrice,
      quantityCounterDisabled,
      unit,
      productsInCartCount,
      onQuantityChange,
      deleteButtonClick,
      addProductToCart,
      buttonTextContextHelp,
      buttonText,
      totalPriceTextFreeProduct,
      isDualPriceLayout,
      priceHistory,
      inSaleInfoMarkLink,
      inSaleInfoMarkText,
      inSaleInfoMarkTextLink,
      productCode,
    } = product;
    const generalProductItem: IGeneralProductItemProps = {
      dataTestId,
      price,
      itemQuantity,
      disabled,
      maximumQuantity,
      isDualPriceLayout,
      priceHistory,
      productCode,
    };
    const imageProps: IImageProps = { imageUrl, itemUrl };
    const textProps: ITextProps = {
      isEngraving,
      textContent,
    };
    const pricePerUnitProps: IPricePerUnitProps = {
      unitPrice,
      inSaleInfoMarkLink,
      inSaleInfoMarkText,
      inSaleInfoMarkTextLink,
    };
    const quantityProps: IQuantityProps = {
      quantityCounterDisabled,
      unit,
      productsInCartCount,
      deleteButtonClick,
      addProductToCart,
      onQuantityChange,
    };
    const buttonProps: IButtonProps = { deleteButtonClick, buttonTextContextHelp, buttonText };
    const totalPrice: ITotalPriceProps = { totalPriceTextFreeProduct };

    return {
      key: product.key,
      generalProductItem,
      imageProps,
      textProps,
      pricePerUnitProps,
      quantityProps,
      buttonProps,
      totalPrice,
      productCode,
    };
  });
};
